// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class LeftPanel {
  width: number;
  projectViewPanelHeight: number;
}
